import React from 'react';
import WiringPage from '../../wiring-page';

import twoPoleImg from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_rs485_master_4p.jpg';
import twoPoleBlueImg from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_blue_rs485_master_4p.jpg';
import fourPoleImg from '../../../../assets/product-interaction/ddsu5168-4p/ddsu5168_4p_rs485_master_4p.jpg';
import sevenPoleImg from '../../../../assets/product-interaction/dtsu5168/dtsu5168_direct_master_4p.jpg';

const diagrams = [
  {
    id: '2p',
    title: '2P 电表接线图',
    tag: 'DDSU5168 2P',
    image: twoPoleImg,
    imageAlt: 'DDSU5168 2P 电表连接 GE400 母表网关接线图'
  },
  {
    id: '2p-blue',
    title: '2P 小蓝点接线图',
    tag: 'DDSU5168 2P',
    image: twoPoleBlueImg,
    imageAlt: 'DDSU5168 2P 小蓝点电表连接 GE400 母表网关接线图'
  },
  {
    id: '4p',
    title: '4P 电表接线图',
    tag: 'DDSU5168 4P',
    image: fourPoleImg,
    imageAlt: 'DDSU5168 4P 电表连接 GE400 母表网关接线图'
  },
  {
    id: '7p',
    title: '7P 电表接线图',
    tag: 'DTSU5168 7P',
    image: sevenPoleImg,
    imageAlt: 'DTSU5168 7P 电表连接 GE400 母表网关接线图'
  }
];

const GE400Wiring = () => (
  <WiringPage
    documentTitle="GE400 接线图｜源一物联"
    heading="GE400"
    backUrl="/product/ge400"
    diagrams={diagrams}
  />
);

export default GE400Wiring;
